export enum MigrationStatus {
  Incomplete = "Incomplete",
  Ready = "Ready",
  Complete = "Complete"
}

export const UploadStatus = MigrationStatus;